import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3355">
      <Navbar data-id="element-3356" />
      <main data-id="element-3357">
        <ConsularAffairs data-id="element-3358" />
      </main>
      <Footer data-id="element-3359" />
      <FeedbackPopup data-id="element-3360" />
    </div>;
}